import { FC } from 'react';
import clsx from 'clsx';

interface TabsInterface {
  tabs: { label: string; value: string }[];
  selected: string;
  onSelect: (value: string) => void;
  className?: string;
}

const Tabs: FC<TabsInterface> = ({ tabs, selected, onSelect, className }) => {
  const handleSelect = (value: string) => {
    onSelect(value);
  };

  return (
    <div
      className={clsx(
        'h-14 p-2 bg-white rounded-lg justify-start items-start gap-2 inline-flex',
        className
      )}
    >
      {tabs.map((option) => {
        const isSelected = option.value === selected;

        return (
          <div
            key={option.value}
            className={clsx(
              'grow shrink basis-0 h-10 px-8 py-2.5 rounded-md justify-center items-center gap-2.5 flex cursor-pointer',
              {
                'bg-[#0f253b] text-white font-bold': isSelected,
                'bg-white text-[#546474] font-medium hover:bg-[#ebeff2]':
                  !isSelected,
              }
            )}
            role="presentation"
            onClick={() => handleSelect(option.value)}
          >
            <div className="text-center text-sm font-['DM Sans'] leading-[18px]">
              {option.label}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default Tabs;
